module.exports = __webpack_public_path__ + "static/media/feat-doctor.fabb0e47.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/feat-doctor.png
// module id = 1258
// module chunks = 0